import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import axios from 'axios';
import AdminDashboard from './AdminDashboard';
import ApplicationsPage from './pages/ApplicationsPage';
import SolutionsPage from './pages/SolutionsPage';
import PackagingPage from './pages/PackagingPage';
import QualityPage from './pages/QualityPage';
import ResourcesPage from './pages/ResourcesPage';
import RequestQuotePage from './pages/RequestQuotePage';
import RequestSamplePage from './pages/RequestSamplePage';
import RequestCOAPage from './pages/RequestCOAPage';
import FarmerPartnershipPage from './pages/FarmerPartnershipPage';
// Product Detail Pages
import AshwagandhaPage from './pages/products/AshwagandhaPage';
import MoringaPage from './pages/products/MoringaPage';
import TurmericPage from './pages/products/TurmericPage';
import GingerPage from './pages/products/GingerPage';
import AmlaPage from './pages/products/AmlaPage';
import NeemPage from './pages/products/NeemPage';
import TulsiPage from './pages/products/TulsiPage';
import BrahmiPage from './pages/products/BrahmiPage';
import ShikakaiPage from './pages/products/ShikakaiPage';
import ReethaPage from './pages/products/ReethaPage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Official PDF URLs (latest from PDF uploads)
const COMPANY_PROFILE_PDF_URL = "https://customer-assets.emergentagent.com/job_e207fe08-869c-4279-b9ff-789e0f1bfe2b/artifacts/y6n7mhsw_HOPE_International_Company_Profile_Rewa_MP.pdf";
const PRODUCT_CATALOGUE_PDF_URL = "https://customer-assets.emergentagent.com/job_e207fe08-869c-4279-b9ff-789e0f1bfe2b/artifacts/99y21fq6_HOPE_International_Product_Catalogue_Rewa_MP.pdf";
// Legacy alias (kept for backward compatibility within file)
const CATALOGUE_PDF_URL = PRODUCT_CATALOGUE_PDF_URL;

// WhatsApp link
const WHATSAPP_MESSAGE = "Hi HOPE INTERNATIONAL, I'm interested in your export products. Please share quotation and product details.";
const WHATSAPP_LINK = `https://wa.me/916267592923?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// Product Card Component with link to detail page
function ProductCard({ image, name, botanical, tagline, productSlug }) {
  const handleQuickInquiry = (e) => {
    e.preventDefault();
    const message = `Hello HOPE INTERNATIONAL,\n\nWe are interested in sourcing ${name}${botanical ? ` (${botanical})` : ""}.\n\nRequired Quantity: [please discuss]\nDestination Country: [please discuss]\nCompany Name: [please discuss]\nPackaging: 25 kg HDPE-lined export bags (food-grade)\n\nPlease share quotation, specification sheet, and export details.\n\nThank you.`;
    const url = `https://wa.me/916267592923?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="product-catalogue-card">
      <div className="product-image-container">
        <img src={image} alt={name} />
      </div>
      <div className="product-info">
        <h3 className="product-name">{name}</h3>
        <p className="product-botanical">{botanical}</p>
        <p className="product-tagline">{tagline}</p>
        
        <Link to={`/product/${productSlug}`} className="btn-view-details">
          View Full Details
          <svg 
            className="details-arrow"
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </Link>
        
        <div className="product-action-buttons">
          <Link to="/request-quote" className="btn-action-quote">Request a Quote</Link>
          <Link to="/request-sample" className="btn-action-sample">Request a Sample</Link>
          <Link to="/request-coa" className="btn-action-coa">Request COA / Specs</Link>
        </div>

        <button
          type="button"
          onClick={handleQuickInquiry}
          className="btn-card-quick-inquiry"
          data-testid={`card-quick-inquiry-${productSlug}`}
          aria-label={`Quick WhatsApp inquiry for ${name}`}
        >
          <svg viewBox="0 0 32 32" width="16" height="16" fill="currentColor" aria-hidden="true">
            <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM21.837 18.989c-0.305-0.153-1.796-0.889-2.074-0.991s-0.48-0.153-0.683 0.153c-0.203 0.305-0.784 0.991-0.961 1.194s-0.355 0.229-0.659 0.076c-0.305-0.153-1.283-0.473-2.444-1.513-0.905-0.809-1.515-1.807-1.692-2.112s-0.018-0.47 0.134-0.622c0.137-0.137 0.305-0.355 0.458-0.533s0.203-0.305 0.305-0.508c0.102-0.203 0.051-0.381-0.025-0.533s-0.683-1.645-0.936-2.254c-0.245-0.592-0.495-0.512-0.683-0.522-0.178-0.010-0.381-0.010-0.584-0.010s-0.533 0.076-0.812 0.381c-0.279 0.305-1.065 1.041-1.065 2.54s1.090 2.947 1.243 3.150c0.153 0.203 2.16 3.298 5.231 4.625 0.731 0.315 1.301 0.504 1.746 0.645 0.733 0.229 1.401 0.195 1.929 0.118 0.588-0.089 1.796-0.736 2.048-1.447s0.254-1.320 0.178-1.447c-0.076-0.127-0.279-0.203-0.584-0.355z" />
          </svg>
          Quick Inquiry on WhatsApp
        </button>

        <p className="product-micro-text">Bulk supply • Export documentation support • Global shipping</p>
      </div>
    </div>
  );
}


function MainWebsite() {
  const [formData, setFormData] = useState({
    name: '',
    companyName: '',
    email: '',
    phone: '',
    country: '',
    product: '',
    quantity: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  // Handle hash navigation on page load
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          const app = document.querySelector('.App');
          if (app) {
            let scrollPosition = 0;
            for (let child of app.children) {
              if (child.id === hash) break;
              scrollPosition += child.offsetHeight;
            }
            const headerOffset = 100;
            const scrollTo = Math.max(0, scrollPosition - headerOffset);
            window.scrollTo({
              top: scrollTo,
              behavior: 'smooth'
            });
            setActiveSection(hash);
          }
        }
      }, 300);
    }
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(`${API}/contact`, {
        name: formData.name,
        email: formData.email,
        country: formData.country,
        message: `Company: ${formData.companyName}\nPhone: ${formData.phone}\nProduct Interest: ${formData.product}\nRequired Quantity: ${formData.quantity}\n\nMessage: ${formData.message}`
      });
      setSubmitStatus({
        type: 'success',
        message: 'Thank you for your inquiry. Our export team will respond within 24 hours.'
      });
      setFormData({ name: '', companyName: '', email: '', phone: '', country: '', product: '', quantity: '', message: '' });
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: 'Failed to send inquiry. Please contact us directly via email or WhatsApp.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToSection = (sectionId) => {
    // Close mobile menu first
    setMobileMenuOpen(false);
    setActiveSection(sectionId);
    
    // Use setTimeout to ensure render completes
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        // Calculate cumulative height by summing all previous siblings
        const app = document.querySelector('.App');
        if (app) {
          let scrollPosition = 0;
          for (let child of app.children) {
            if (child.id === sectionId) break;
            scrollPosition += child.offsetHeight;
          }
          
          const headerOffset = 100;
          const scrollTo = Math.max(0, scrollPosition - headerOffset);
          
          window.scrollTo({
            top: scrollTo,
            behavior: 'smooth'
          });
        }
      }
    }, 0);
  };

  return (
    <div className="App">
      {/* HEADER */}
      <header className="site-header">
        <div className="header-container">
          <div className="logo-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_hopeherbals/artifacts/a098rm1o_20251223_224120_0000.png" 
              alt="Hope International Logo" 
              className="logo-image"
            />
            <div className="brand-text">
              <h1 className="brand-name">HOPE INTERNATIONAL</h1>
              <p className="brand-tagline-header">Premium Herbal Exports • Est. 2019</p>
            </div>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="header-nav">
            <button onClick={() => scrollToSection('home')} className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}>Home</button>
            <button onClick={() => scrollToSection('products')} className={`nav-link ${activeSection === 'products' ? 'active' : ''}`}>Products</button>
            <Link to="/applications" className="nav-link">Applications</Link>
            <Link to="/solutions" className="nav-link">Solutions</Link>
            <div className="nav-dropdown">
              <button className="nav-link dropdown-trigger">Resources ▾</button>
              <div className="dropdown-menu">
                <Link to="/quality" className="dropdown-item">Quality & Compliance</Link>
                <Link to="/packaging" className="dropdown-item">Packaging</Link>
                <Link to="/resources" className="dropdown-item">Downloads</Link>
                <Link to="/farmer-partnership" className="dropdown-item">Farmer Partnership</Link>
              </div>
            </div>
            <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
            <Link to="/request-quote" className="nav-cta-quote">Request a Quote</Link>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <button onClick={() => scrollToSection('home')} className="mobile-nav-link">Home</button>
            <button onClick={() => scrollToSection('products')} className="mobile-nav-link">Products</button>
            <Link to="/applications" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Applications</Link>
            <Link to="/solutions" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Solutions</Link>
            <Link to="/quality" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Quality & Compliance</Link>
            <Link to="/packaging" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Packaging</Link>
            <Link to="/resources" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Resources</Link>
            <Link to="/farmer-partnership" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Farmer Partnership</Link>
            <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">Contact</button>
            <Link to="/request-quote" className="mobile-nav-cta" onClick={() => setMobileMenuOpen(false)}>Request a Quote</Link>
          </div>
        )}
      </header>

      {/* HOME / HERO SECTION */}
      <section id="home" className="hero-section-export">
        <div className="hero-container">
          <div className="hero-content-export">
            <p className="hero-eyebrow">Premium Indian Herbal Powder Exporter • Est. 2019</p>
            <h1 className="hero-main-title">HOPE INTERNATIONAL</h1>
            <h2 className="hero-official-tagline">Pure by Nature. Trusted Worldwide.</h2>
            <p className="hero-sub-headline">Bringing Nature's Purity to the World — Bulk Herbal Powders, Ayurvedic Herbs & Superfoods for Global B2B Buyers</p>
            
            <div className="hero-cta-buttons">
              <Link to="/request-quote" className="btn-cta-primary" data-testid="hero-request-quote-btn">Request Bulk Quote</Link>
              <a href={PRODUCT_CATALOGUE_PDF_URL} target="_blank" rel="noopener noreferrer" className="btn-cta-secondary" data-testid="hero-download-catalogue-btn">Request Product Catalogue</a>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-cta-whatsapp-hero" data-testid="hero-whatsapp-btn">
                <svg viewBox="0 0 32 32" width="20" height="20" fill="currentColor" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM21.837 18.989c-0.305-0.153-1.796-0.889-2.074-0.991s-0.48-0.153-0.683 0.153c-0.203 0.305-0.784 0.991-0.961 1.194s-0.355 0.229-0.659 0.076c-0.305-0.153-1.283-0.473-2.444-1.513-0.905-0.809-1.515-1.807-1.692-2.112s-0.018-0.47 0.134-0.622c0.137-0.137 0.305-0.355 0.458-0.533s0.203-0.305 0.305-0.508c0.102-0.203 0.051-0.381-0.025-0.533s-0.683-1.645-0.936-2.254c-0.245-0.592-0.495-0.512-0.683-0.522-0.178-0.010-0.381-0.010-0.584-0.010s-0.533 0.076-0.812 0.381c-0.279 0.305-1.065 1.041-1.065 2.54s1.090 2.947 1.243 3.150c0.153 0.203 2.16 3.298 5.231 4.625 0.731 0.315 1.301 0.504 1.746 0.645 0.733 0.229 1.401 0.195 1.929 0.118 0.588-0.089 1.796-0.736 2.048-1.447s0.254-1.320 0.178-1.447c-0.076-0.127-0.279-0.203-0.584-0.355z" />
                </svg>
                WhatsApp Inquiry
              </a>
            </div>
            
            <div className="hero-trust-indicators">
              <div className="trust-item">
                <span className="trust-icon">✓</span>
                <span>100% Natural & Pure</span>
              </div>
              <div className="trust-item">
                <span className="trust-icon">✓</span>
                <span>Lab Tested & Certified</span>
              </div>
              <div className="trust-item">
                <span className="trust-icon">✓</span>
                <span>Global Export Standards</span>
              </div>
              <div className="trust-item">
                <span className="trust-icon">✓</span>
                <span>Trusted Worldwide</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HERO INTRO SECTION */}
      <section className="hero-intro-section">
        <div className="container">
          <div className="hero-intro-content">
            <p className="hero-intro-text">
              <strong>Hope International</strong> is an Indian exporter specializing in premium herbal and natural powders for international bulk buyers. Established in 2019 and based in Rewa, Madhya Pradesh, we serve nutraceutical manufacturers, supplement brands, food processors, and importers across global markets.
            </p>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="why-choose-section">
        <div className="container">
          <div className="section-header-professional">
            <h2 className="section-title-professional">Why Choose Hope International</h2>
            <div className="title-underline"></div>
          </div>
          
          <div className="why-choose-grid">
            <div className="why-choose-card">
              <div className="why-choose-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4>Established Exporter Since 2019</h4>
              <p>Years of experience in international herbal powder exports with a proven track record of reliable supply.</p>
            </div>
            
            <div className="why-choose-card">
              <div className="why-choose-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4>Export-Grade Quality Focus</h4>
              <p>Every batch is lab tested and processed to meet international quality standards and buyer specifications.</p>
            </div>
            
            <div className="why-choose-card">
              <div className="why-choose-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
              </div>
              <h4>Bulk Supply Capability</h4>
              <p>Flexible MOQs from 100kg to container loads with consistent monthly supply capacity of 100+ MT.</p>
            </div>
            
            <div className="why-choose-card">
              <div className="why-choose-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h4>Transparent Export Documentation</h4>
              <p>Complete paperwork support including COA, Certificate of Origin, Phytosanitary, and customs documents.</p>
            </div>
            
            <div className="why-choose-card">
              <div className="why-choose-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h4>Long-Term Buyer Partnerships</h4>
              <p>We prioritize building lasting relationships with importers, distributors, and manufacturing partners worldwide.</p>
            </div>
          </div>

          {/* Trust Strip - subtle */}
          <div className="why-choose-trust-strip">
            <p>Products sourced from certified manufacturing partners — see full credentials in <a href="#certifications">Certifications</a>.</p>
          </div>
        </div>
      </section>

      {/* ============================================
          CERTIFICATIONS SECTION — 15 Premium Badges
          ============================================ */}
      <section id="certifications" className="certifications-premium-section">
        <div className="container">
          <div className="section-header-professional">
            <p className="section-eyebrow">Supplier-Certified Manufacturing Facilities</p>
            <h2 className="section-title-professional">International Compliance & Quality Standards</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle-professional">Our sourcing and manufacturing partners hold these globally-recognised certifications — documentation provided per shipment.</p>
          </div>

          <div className="cert-premium-grid">
            <div className="cert-mark" title="Food Safety and Standards Authority of India">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4m5.5 2.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"/></svg>
              </div>
              <h4>FSSAI</h4>
              <p>Food Safety Authority of India</p>
            </div>
            <div className="cert-mark" title="USDA Organic — National Organic Program">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
              </div>
              <h4>USDA Organic</h4>
              <p>National Organic Program (NOP)</p>
            </div>
            <div className="cert-mark" title="National Programme for Organic Production (India)">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/></svg>
              </div>
              <h4>NPOP Organic</h4>
              <p>India Organic Standard</p>
            </div>
            <div className="cert-mark" title="US Food and Drug Administration registered facility">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              </div>
              <h4>FDA Registered</h4>
              <p>US Food & Drug Administration</p>
            </div>
            <div className="cert-mark" title="Halal Certified processing">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>
              </div>
              <h4>HALAL</h4>
              <p>Halal-Compliant Sourcing</p>
            </div>
            <div className="cert-mark" title="Kosher Certified processing">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2l1.5 4.5h4.5l-3.75 2.75 1.5 4.5L12 11l-3.75 2.75 1.5-4.5L6 6.5h4.5L12 2z"/></svg>
              </div>
              <h4>KOSHER</h4>
              <p>Kosher-Compliant Sourcing</p>
            </div>
            <div className="cert-mark" title="Good Manufacturing Practices">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 12l2 2 4-4"/></svg>
              </div>
              <h4>GMP</h4>
              <p>Good Manufacturing Practices</p>
            </div>
            <div className="cert-mark" title="Current Good Manufacturing Practices">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11H5a2 2 0 00-2 2v7h18v-7a2 2 0 00-2-2h-4M9 11V5a3 3 0 016 0v6"/></svg>
              </div>
              <h4>cGMP</h4>
              <p>Current Good Manufacturing Practices</p>
            </div>
            <div className="cert-mark" title="Hazard Analysis & Critical Control Points">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              </div>
              <h4>HACCP</h4>
              <p>Hazard Analysis Critical Control Points</p>
            </div>
            <div className="cert-mark" title="ISO 22000 Food Safety Management">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
              </div>
              <h4>ISO 22000</h4>
              <p>Food Safety Management System</p>
            </div>
            <div className="cert-mark" title="Agricultural and Processed Food Products Export Development Authority">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 22V8a4 4 0 014-4h12a4 4 0 014 4v14M2 22h20M9 22V12h6v10"/></svg>
              </div>
              <h4>APEDA</h4>
              <p>India's Agri Export Authority</p>
            </div>
            <div className="cert-mark" title="Chemical and Allied Export Promotion Council">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              </div>
              <h4>CHEMEXCIL</h4>
              <p>India Export Promotion Council</p>
            </div>
            <div className="cert-mark" title="Spices Board India — Government export authority">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
              </div>
              <h4>Spice Board</h4>
              <p>Government of India Spices Authority</p>
            </div>
            <div className="cert-mark" title="100% Plant-Based — Vegan Friendly">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2c4 6 4 12 0 20-4-8-4-14 0-20zM4 12c4-2 8-2 16 0M4 12c4 2 8 2 16 0"/></svg>
              </div>
              <h4>VEGAN</h4>
              <p>100% Plant-Based</p>
            </div>
            <div className="cert-mark" title="Cruelty-Free — No Animal Testing">
              <div className="cert-mark-seal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="13" r="6"/><circle cx="6" cy="6" r="2"/><circle cx="18" cy="6" r="2"/><circle cx="4" cy="11" r="1.5"/><circle cx="20" cy="11" r="1.5"/></svg>
              </div>
              <h4>Cruelty Free</h4>
              <p>No Animal Testing</p>
            </div>
          </div>

          <div className="cert-premium-disclaimer">
            <p><strong>Important Compliance Note:</strong> Products sourced from certified manufacturing partners. Hope International does not claim direct ownership of these certifications. Certifications are batch-specific and supplier-specific; original documentation is shared with buyers per shipment and as per destination-country requirements.</p>
          </div>
        </div>
      </section>

      {/* ABOUT US SECTION */}
      <section id="about" className="about-section-professional">
        <div className="container">
          <div className="section-header-professional">
            <p className="section-eyebrow">Bringing Nature's Purity to the World</p>
            <h2 className="section-title-professional">About Hope International</h2>
            <div className="title-underline"></div>
          </div>

          <div className="about-content-professional">
            <div className="about-intro">
              <p className="about-tagline-placement">Pure by Nature. Trusted Worldwide.</p>
              <p className="about-text">
                <strong>Hope International</strong> is a trusted Indian exporter of high-quality herbal products. Founded with a vision to promote natural wellness, we are committed to providing pure, authentic, and effective herbal products to international buyers since 2019.
              </p>
              <p className="about-text">
                Our products are carefully sourced, scientifically processed, and hygienically packed to retain their natural goodness and potency. Based in Rewa, Madhya Pradesh, India, we specialize in herbal powders, Ayurvedic herbs, and superfoods — serving nutraceutical manufacturers, supplement brands, food processors, and importers across the globe.
              </p>
            </div>

            {/* Mission, Vision, Values from Company Profile */}
            <div className="mvv-grid">
              <div className="mvv-card">
                <div className="mvv-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
                </div>
                <h3>Our Mission</h3>
                <p>To provide high-quality, pure, and sustainable herbal products that enhance well-being and create value for our customers and communities.</p>
              </div>
              <div className="mvv-card">
                <div className="mvv-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                </div>
                <h3>Our Vision</h3>
                <p>To be a globally trusted name in the herbal products industry, delivering nature's best with integrity and excellence.</p>
              </div>
              <div className="mvv-card">
                <div className="mvv-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
                </div>
                <h3>Our Values</h3>
                <p><strong>Quality First</strong> · <strong>Integrity</strong> · <strong>Sustainability</strong> · <strong>Customer Satisfaction</strong> · <strong>Commitment</strong></p>
              </div>
            </div>

            <div className="about-highlights-grid">
              <div className="about-highlight-card">
                <h4>Quality Sourcing</h4>
                <p>We source from trusted suppliers, ensuring traceability and consistent quality in every shipment.</p>
              </div>
              <div className="about-highlight-card">
                <h4>Export Compliance</h4>
                <p>Full documentation support including COA, phytosanitary certificates, and all necessary export paperwork for customs clearance.</p>
              </div>
              <div className="about-highlight-card">
                <h4>Global Partnerships</h4>
                <p>Serving nutraceutical manufacturers, supplement brands, and importers across North America, Europe, Middle East, and Asia-Pacific.</p>
              </div>
              <div className="about-highlight-card">
                <h4>Reliable Supply</h4>
                <p>Consistent bulk supply capability with flexible MOQs, container load shipments, and customizable packaging options.</p>
              </div>
            </div>

            <div className="company-facts">
              <div className="fact-item">
                <div className="fact-label">Established</div>
                <div className="fact-value">2019</div>
              </div>
              <div className="fact-item">
                <div className="fact-label">Location</div>
                <div className="fact-value">Rewa, Madhya Pradesh, India</div>
              </div>
              <div className="fact-item">
                <div className="fact-label">Specialization</div>
                <div className="fact-value">Herbal Powders, Ayurvedic Herbs & Superfoods</div>
              </div>
              <div className="fact-item">
                <div className="fact-label">Export Capacity</div>
                <div className="fact-value">1000+ MT/Year</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRODUCTS SECTION */}
      <section id="products" className="products-section-catalogue">
        <div className="container">
          <div className="section-header-professional">
            <h2 className="section-title-professional">Product Catalogue</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle-professional">Export-Grade Herbal & Natural Powders</p>
          </div>

          <div className="product-catalogue-grid">
            <ProductCard
              image="https://customer-assets.emergentagent.com/job_premium-herbs-1/artifacts/im93abo2_ChatGPT%20Image%20Dec%2025%2C%202025%2C%2011_05_40%20PM.png"
              name="Ashwagandha Root Powder"
              botanical="Withania somnifera"
              tagline="Premium adaptogenic herb for wellness formulations"
              productSlug="ashwagandha"
            />

            <ProductCard
              image="https://customer-assets.emergentagent.com/job_premium-herbs-1/artifacts/enu208wz_ChatGPT%20Image%20Dec%2025%2C%202025%2C%2011_07_14%20PM.png"
              name="Moringa Leaf Powder"
              botanical="Moringa oleifera"
              tagline="Nutrient-dense superfood for health supplements"
              productSlug="moringa"
            />

            <ProductCard
              image="https://customer-assets.emergentagent.com/job_premium-herbs-1/artifacts/ytxy331b_ChatGPT%20Image%20Dec%2025%2C%202025%2C%2011_17_43%20PM.png"
              name="Turmeric Powder"
              botanical="Curcuma longa"
              tagline="Golden spice with natural curcumin content"
              productSlug="turmeric"
            />

            <ProductCard
              image="https://customer-assets.emergentagent.com/job_premium-herbs-1/artifacts/p3v6djrq_ChatGPT%20Image%20Dec%2025%2C%202025%2C%2011_19_21%20PM.png"
              name="Ginger Powder"
              botanical="Zingiber officinale"
              tagline="Aromatic spice for food and nutraceuticals"
              productSlug="ginger"
            />

            <ProductCard
              image="https://static.prod-images.emergentagent.com/jobs/e207fe08-869c-4279-b9ff-789e0f1bfe2b/images/9d3e326662832b8a2ddccea2c468c2227cb47fbe805a0ab4d962af1ca1699a5d.png"
              name="Amla Fruit Powder"
              botanical="Emblica officinalis"
              tagline="Vitamin C rich Indian gooseberry powder"
              productSlug="amla"
            />

            <ProductCard
              image="https://static.prod-images.emergentagent.com/jobs/e207fe08-869c-4279-b9ff-789e0f1bfe2b/images/2ce2b5745ab3ae6cb1af819fca9f5b4e7e4b9ac9fd124ed11c191a12989c9727.png"
              name="Neem Leaf Powder"
              botanical="Azadirachta indica"
              tagline="Traditional herb for natural wellness products"
              productSlug="neem"
            />

            <ProductCard
              image="https://static.prod-images.emergentagent.com/jobs/e207fe08-869c-4279-b9ff-789e0f1bfe2b/images/27436d40e82d926e247fe73128b8cb0fb09c60caf04890bf2ff021f0b3a363ef.png"
              name="Tulsi Leaf Powder"
              botanical="Ocimum sanctum"
              tagline="Adaptogenic herb supporting immunity & respiratory health"
              productSlug="tulsi"
            />

            <ProductCard
              image="https://static.prod-images.emergentagent.com/jobs/e207fe08-869c-4279-b9ff-789e0f1bfe2b/images/e9e20b7e1768e1fed66a3177904d7d8fcf8b30b3677f93208e35dc6841966cf4.png"
              name="Brahmi Powder"
              botanical="Bacopa monnieri"
              tagline="Supports memory, focus and mental well-being"
              productSlug="brahmi"
            />

            <ProductCard
              image="https://static.prod-images.emergentagent.com/jobs/e207fe08-869c-4279-b9ff-789e0f1bfe2b/images/3466b147a4c929920c434c8256689426d4d85493e6f0d29145e86c591f1e790b.png"
              name="Shikakai Powder"
              botanical="Acacia concinna"
              tagline="Natural hair cleanser for cosmetic formulations"
              productSlug="shikakai"
            />

            <ProductCard
              image="https://static.prod-images.emergentagent.com/jobs/e207fe08-869c-4279-b9ff-789e0f1bfe2b/images/6d3bbfe21e889ebace722e284852dbab6471b25cbdc07ab3b740565e0edcf5c6.png"
              name="Reetha Powder"
              botanical="Sapindus mukorossi"
              tagline="Traditional herbal cleanser for hair & skin care"
              productSlug="reetha"
            />
          </div>

          <div className="catalogue-note">
            <p><strong>Note:</strong> Complete product specifications, COA samples, and bulk pricing available upon request. We also supply other herbal and vegetable powders not listed above. Please contact us for specific requirements.</p>
            <p className="availability-disclaimer"><strong>Disclaimer:</strong> Product availability, specifications, and certifications are subject to confirmation based on batch readiness and buyer requirements.</p>
          </div>
        </div>
      </section>

      {/* QUALITY & COMPLIANCE SECTION */}
      <section id="quality" className="quality-section-professional">
        <div className="container">
          <div className="section-header-professional">
            <h2 className="section-title-professional">Quality & Compliance</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle-professional">Export-Ready Quality Assurance for International Markets</p>
          </div>

          <div className="quality-content-grid">
            <div className="quality-main-content">
              <h3>Batch-Wise Laboratory Testing</h3>
              <p>All export shipments are subject to batch-wise laboratory testing through accredited laboratories. Our testing protocol ensures compliance with international import requirements.</p>
              
              <h4>Typical Test Parameters:</h4>
              <ul className="quality-list">
                <li><strong>Microbiology:</strong> Total Plate Count, Yeast & Mold, E. coli, Salmonella</li>
                <li><strong>Heavy Metals:</strong> Lead, Cadmium, Arsenic, Mercury (via ICP-MS)</li>
                <li><strong>Moisture / Loss on Drying</strong></li>
                <li><strong>Pesticide Residue Analysis</strong> (where applicable)</li>
              </ul>

              <h3>Certificate of Analysis (COA)</h3>
              <p>Batch-specific Certificates of Analysis are issued and shared with buyers upon request. COA samples are available for evaluation and approval before order placement.</p>

              <h3>Export Documentation</h3>
              <p>Export documentation is prepared in line with import requirements for UAE, EU, UK, and USA markets. Complete documentation support ensures smooth customs clearance at destination.</p>
              
              <h3>Supplier Traceability</h3>
              <p>Products are sourced from manufacturing facilities in India. Each batch is traceable and tested prior to export. Supplier identities are not publicly disclosed. Quality verification and export documentation are controlled by Hope International.</p>
            </div>

            <div className="certifications-sidebar">
              <div className="cert-box">
                <h4>Laboratory Testing</h4>
                <p>Accredited laboratory testing for all export batches</p>
              </div>
              <div className="cert-box">
                <h4>Quality Assurance</h4>
                <p>Consistent quality checks and verification for every shipment</p>
              </div>
              <div className="cert-box">
                <h4>Export Documentation</h4>
                <p>Complete documentation for UAE, EU, UK, and USA market requirements</p>
              </div>
              <div className="cert-box">
                <h4>Batch Traceability</h4>
                <p>Full traceability from sourcing to shipment for every batch</p>
              </div>
            </div>
          </div>

          <div className="compliance-statement">
            <p><strong>Certification Disclosure:</strong> Products are sourced from approved manufacturing partners who hold relevant certifications including FDA registration, Halal certification, Kosher, and Organic certification (USDA NOP / NPOP) where applicable. Hope International does not claim ownership of these certifications. Certifications are batch-specific and supplier-specific, and documentation is shared with buyers upon request. Export compliance and documentation are managed by Hope International. <a href="#certifications">View all 15 certifications →</a></p>
          </div>
        </div>
      </section>

      {/* EXPORT CAPABILITIES SECTION */}
      <section id="export" className="export-section-professional">
        <div className="container">
          <div className="section-header-professional">
            <h2 className="section-title-professional">Export Capabilities</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle-professional">Complete Export Solutions for International Buyers</p>
          </div>

          <div className="export-capabilities-grid">
            <div className="export-capability-card">
              <h3>Bulk Supply Capability</h3>
              <ul>
                <li>Minimum Order Quantity: 100kg (product dependent)</li>
                <li>Container Load shipments available</li>
                <li>Monthly supply capacity: 100+ MT across product range</li>
                <li>Consistent quality across large volumes</li>
              </ul>
            </div>

            <div className="export-capability-card">
              <h3>Custom Packaging</h3>
              <ul>
                <li>Standard export packaging: 20kg, 25kg bags</li>
                <li>Custom packaging options available</li>
                <li>Food-grade HDPE, PP bags for safe transport</li>
                <li>Labeling as per buyer specifications</li>
              </ul>
            </div>

            <div className="export-capability-card">
              <h3>Private Labeling</h3>
              <ul>
                <li>Private label packaging available</li>
                <li>Custom branding for importers and distributors</li>
                <li>Product formulation support</li>
                <li>Flexible packaging designs</li>
              </ul>
            </div>
          </div>

          <div className="export-documentation-section">
            <h3>Export Documentation Support</h3>
            <p>We provide complete export documentation to ensure smooth customs clearance:</p>
            <div className="documentation-grid">
              <div className="doc-item">
                <span className="doc-icon">✓</span>
                <span>Commercial Invoice</span>
              </div>
              <div className="doc-item">
                <span className="doc-icon">✓</span>
                <span>Packing List</span>
              </div>
              <div className="doc-item">
                <span className="doc-icon">✓</span>
                <span>Certificate of Origin</span>
              </div>
              <div className="doc-item">
                <span className="doc-icon">✓</span>
                <span>Phytosanitary Certificate</span>
              </div>
              <div className="doc-item">
                <span className="doc-icon">✓</span>
                <span>Certificate of Analysis (COA)</span>
              </div>
              <div className="doc-item">
                <span className="doc-icon">✓</span>
                <span>Material Safety Data Sheet (MSDS)</span>
              </div>
              <div className="doc-item">
                <span className="doc-icon">✓</span>
                <span>Bill of Lading</span>
              </div>
              <div className="doc-item">
                <span className="doc-icon">✓</span>
                <span>Health Certificate (if required)</span>
              </div>
            </div>
          </div>

          <div className="markets-served-section">
            <h3>Markets We Serve</h3>
            <div className="markets-grid">
              <div className="market-card">
                <h4>North America</h4>
                <p>USA, Canada</p>
              </div>
              <div className="market-card">
                <h4>Europe</h4>
                <p>Germany, UK, Netherlands, France</p>
              </div>
              <div className="market-card">
                <h4>Middle East</h4>
                <p>UAE, Saudi Arabia, Qatar</p>
              </div>
              <div className="market-card">
                <h4>Asia-Pacific</h4>
                <p>Australia, Singapore, Japan, South Korea</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW WE WORK SECTION */}
      <section id="how-we-work" className="how-we-work-section">
        <div className="container">
          <div className="section-header-professional">
            <h2 className="section-title-professional">How We Work</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle-professional">Our Export Process</p>
          </div>

          <div className="process-steps-grid">
            <div className="process-step">
              <div className="step-number">1</div>
              <h4>Buyer Inquiry</h4>
              <p>Share your product requirements and destination market</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h4>Product Specification Sharing</h4>
              <p>We provide detailed specs, COA samples, and product information</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h4>Pricing & Incoterms Confirmation</h4>
              <p>Final pricing based on quantity, packaging, and shipping terms</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h4>Sample & Batch-wise COA</h4>
              <p>Sample dispatch with batch-specific Certificate of Analysis</p>
            </div>
            <div className="process-step">
              <div className="step-number">5</div>
              <h4>Order Confirmation (PO)</h4>
              <p>Purchase order confirmation and production scheduling</p>
            </div>
            <div className="process-step">
              <div className="step-number">6</div>
              <h4>Export Documentation & Shipment</h4>
              <p>Complete documentation and shipment coordination</p>
            </div>
          </div>
        </div>
      </section>

      {/* DOWNLOADS SECTION */}
      <section id="downloads" className="downloads-section">
        <div className="container">
          <div className="section-header-professional">
            <p className="section-eyebrow">Resources for Buyers</p>
            <h2 className="section-title-professional">Downloads & Documentation</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle-professional">Get the official Company Profile, full Product Catalogue, and request batch-specific documents.</p>
          </div>

          <div className="downloads-grid-premium">
            <a href={COMPANY_PROFILE_PDF_URL} target="_blank" rel="noopener noreferrer" className="download-card" data-testid="download-company-profile-btn">
              <div className="download-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/></svg>
              </div>
              <h4>Company Profile</h4>
              <p>Complete company overview, mission, vision, certifications & contact</p>
              <span className="download-cta">Download PDF →</span>
            </a>

            <a href={PRODUCT_CATALOGUE_PDF_URL} target="_blank" rel="noopener noreferrer" className="download-card" data-testid="download-product-catalogue-btn">
              <div className="download-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>
              </div>
              <h4>Product Catalogue</h4>
              <p>Full range of herbal powders with descriptions, packaging & quality info</p>
              <span className="download-cta">Download PDF →</span>
            </a>

            <Link to="/request-coa" className="download-card" data-testid="download-request-coa-btn">
              <div className="download-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
              </div>
              <h4>Request COA</h4>
              <p>Get a batch-specific Certificate of Analysis for any product</p>
              <span className="download-cta">Request →</span>
            </Link>

            <Link to="/request-coa" className="download-card" data-testid="download-request-spec-btn">
              <div className="download-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
              </div>
              <h4>Request Specification Sheet</h4>
              <p>Detailed product specifications for nutraceutical & cosmetic R&D</p>
              <span className="download-cta">Request →</span>
            </Link>
          </div>
        </div>
      </section>

      {/* BUYER FAQS SECTION */}
      <section id="faqs" className="faqs-section">
        <div className="container">
          <div className="section-header-professional">
            <h2 className="section-title-professional">Buyer FAQs</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle-professional">Frequently Asked Questions</p>
          </div>

          <div className="faqs-grid">
            <div className="faq-item">
              <h4>What is your MOQ?</h4>
              <p>Minimum 50–100 kg depending on product and destination market.</p>
            </div>
            <div className="faq-item">
              <h4>Do you provide COA?</h4>
              <p>Yes, batch-wise COA is provided through NABL / ISO 17025 accredited laboratories.</p>
            </div>
            <div className="faq-item">
              <h4>What is your typical lead time?</h4>
              <p>7–14 working days after order confirmation, depending on product and quantity.</p>
            </div>
            <div className="faq-item">
              <h4>What packaging do you offer?</h4>
              <p>Standard export packing in 25 kg HDPE drums with inner food-grade liner.</p>
            </div>
            <div className="faq-item">
              <h4>Which markets do you serve?</h4>
              <p>UAE, UK, EU, and USA.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section id="contact" className="contact-section-professional">
        <div className="container">
          <div className="section-header-professional">
            <h2 className="section-title-professional">Contact Us</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle-professional">For bulk export inquiries and long-term supply partnerships, contact us.</p>
          </div>

          <div className="contact-grid-professional">
            <div className="contact-info-professional">
              <h3>Hope International</h3>
              <p className="contact-description">For bulk quotations, product specifications, COA samples, and all export inquiries, please use the form or contact us directly.</p>
              
              <div className="contact-details-list">
                <div className="contact-detail-item">
                  <strong>Business Name:</strong>
                  <p>Hope International</p>
                </div>
                <div className="contact-detail-item">
                  <strong>Established:</strong>
                  <p>2019</p>
                </div>
                <div className="contact-detail-item">
                  <strong>Location:</strong>
                  <p>Ashiyana Tower, Gulab Nagar, Rewa, Madhya Pradesh, India</p>
                </div>
                <div className="contact-detail-item">
                  <strong>Email:</strong>
                  <p><a href="mailto:Abhishek@hopeinternational.in">Abhishek@hopeinternational.in</a></p>
                </div>
                <div className="contact-detail-item">
                  <strong>Phone / WhatsApp:</strong>
                  <p><a href="tel:+916267592923">+91 6267592923</a></p>
                </div>
                <div className="contact-detail-item">
                  <strong>Business Hours:</strong>
                  <p>Monday - Saturday: 9:00 AM - 6:00 PM IST</p>
                </div>
              </div>
            </div>

            <div className="contact-form-professional">
              <h3>Send Bulk Inquiry</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-row-professional">
                  <div className="form-group-professional">
                    <label>Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      disabled={isSubmitting}
                      placeholder="Your full name"
                    />
                  </div>
                  <div className="form-group-professional">
                    <label>Company Name *</label>
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      required
                      disabled={isSubmitting}
                      placeholder="Your company name"
                    />
                  </div>
                </div>

                <div className="form-row-professional">
                  <div className="form-group-professional">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      disabled={isSubmitting}
                      placeholder="business@company.com"
                    />
                  </div>
                  <div className="form-group-professional">
                    <label>Phone / WhatsApp</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                      placeholder="+1 234 567 8900"
                    />
                  </div>
                </div>

                <div className="form-row-professional">
                  <div className="form-group-professional">
                    <label>Country *</label>
                    <input
                      type="text"
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                      required
                      disabled={isSubmitting}
                      placeholder="e.g., United States, Germany"
                    />
                  </div>
                  <div className="form-group-professional">
                    <label>Product of Interest *</label>
                    <input
                      type="text"
                      name="product"
                      value={formData.product}
                      onChange={handleInputChange}
                      required
                      placeholder="e.g., Ashwagandha Powder, Moringa"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="form-group-professional">
                  <label>Required Quantity *</label>
                  <input
                    type="text"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleInputChange}
                    required
                    placeholder="e.g., 500kg, 5MT, 1 Container (20ft)"
                    disabled={isSubmitting}
                  />
                </div>

                <div className="form-group-professional">
                  <label>Message / Additional Requirements</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder="Please share any specific requirements such as quality specifications, packaging preferences, delivery timeline, etc."
                    disabled={isSubmitting}
                  ></textarea>
                </div>

                <button type="submit" className="btn-submit-professional" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Submit Bulk Inquiry'}
                </button>

                {submitStatus && (
                  <div className={`form-status-professional ${submitStatus.type}`}>
                    {submitStatus.message}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer-professional">
        <div className="container">
          <div className="footer-content-grid">
            <div className="footer-col-main">
              <img 
                src="https://customer-assets.emergentagent.com/job_hopeherbals/artifacts/a098rm1o_20251223_224120_0000.png" 
                alt="Hope International Logo" 
                className="footer-logo"
              />
              <h3 className="footer-brand-name">HOPE INTERNATIONAL</h3>
              <p className="footer-tagline">Pure by Nature. Trusted Worldwide.</p>
              <p className="footer-text">Bringing nature's purity to the world. Indian exporter of premium herbal & natural powders since 2019.</p>
            </div>
            
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul>
                <li><button onClick={() => scrollToSection('home')}>Home</button></li>
                <li><button onClick={() => scrollToSection('about')}>About Us</button></li>
                <li><button onClick={() => scrollToSection('products')}>Products</button></li>
                <li><button onClick={() => scrollToSection('certifications')}>Certifications</button></li>
                <li><button onClick={() => scrollToSection('quality')}>Quality & Compliance</button></li>
                <li><button onClick={() => scrollToSection('export')}>Export Capabilities</button></li>
                <li><Link to="/farmer-partnership">Farmer Partnership</Link></li>
              </ul>
            </div>
            
            <div className="footer-col">
              <h4>Our Products</h4>
              <ul>
                <li><Link to="/product/ashwagandha">Ashwagandha Powder</Link></li>
                <li><Link to="/product/moringa">Moringa Leaf Powder</Link></li>
                <li><Link to="/product/turmeric">Turmeric Powder</Link></li>
                <li><Link to="/product/ginger">Ginger Powder</Link></li>
                <li><Link to="/product/amla">Amla Powder</Link></li>
                <li><Link to="/product/neem">Neem Powder</Link></li>
                <li><Link to="/product/tulsi">Tulsi Powder</Link></li>
                <li><Link to="/product/brahmi">Brahmi Powder</Link></li>
                <li><Link to="/product/shikakai">Shikakai Powder</Link></li>
                <li><Link to="/product/reetha">Reetha Powder</Link></li>
              </ul>
            </div>
            
            <div className="footer-col">
              <h4>Contact</h4>
              <ul>
                <li>Ashiyana Tower, Gulab Nagar, Rewa, M.P., India</li>
                <li><a href="mailto:Abhishek@hopeinternational.in">Abhishek@hopeinternational.in</a></li>
                <li><a href="tel:+916267592923">+91 6267592923</a></li>
              </ul>
              <div className="footer-social">
                <a href="https://www.instagram.com/hopei_nternational.in" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/hopeinternationals/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Supplier Compliance Reminder */}
          <div className="footer-compliance-strip">
            <p className="footer-compliance-text">
              <strong>Products sourced from certified manufacturing partners.</strong> Hope International does not directly hold these certifications. <a href="/#certifications">View 15 supplier compliance credentials →</a>
            </p>
            <p className="footer-compliance-disclaimer">
              Certifications are batch-specific and supplier-specific. Original documentation shared with buyers upon request and per destination-country requirements.
            </p>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; 2019-2025 Hope International. All Rights Reserved. | Exporter of Premium Herbal & Natural Powders</p>
            <p className="footer-tagline-bottom">Pure by Nature. Trusted Worldwide. | Bulk Supply | Export Support | Private Label Packaging Available</p>
            <p className="footer-gst">GST: 23BGUPM0733M2Z0</p>
          </div>
        </div>
      </footer>

      {/* FLOATING ACTION BUTTONS */}
      <a
        href="tel:+916267592923"
        aria-label="Call Now"
        className="phone-float"
      >
        <svg viewBox="0 0 24 24" className="phone-icon" fill="white">
          <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
        </svg>
      </a>

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Chat"
        className="whatsapp-float"
      >
        <svg viewBox="0 0 32 32" className="whatsapp-icon">
          <path fill="white" d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.924 0-7.435 6.052-13.487 13.487-13.487s13.487 6.052 13.487 13.487c0 7.435-6.052 13.487-13.487 13.487zM21.837 18.989c-0.305-0.153-1.796-0.889-2.074-0.991s-0.48-0.153-0.683 0.153c-0.203 0.305-0.784 0.991-0.961 1.194s-0.355 0.229-0.659 0.076c-0.305-0.153-1.283-0.473-2.444-1.513-0.905-0.809-1.515-1.807-1.692-2.112s-0.018-0.47 0.134-0.622c0.137-0.137 0.305-0.355 0.458-0.533s0.203-0.305 0.305-0.508c0.102-0.203 0.051-0.381-0.025-0.533s-0.683-1.645-0.936-2.254c-0.245-0.592-0.495-0.512-0.683-0.522-0.178-0.010-0.381-0.010-0.584-0.010s-0.533 0.076-0.812 0.381c-0.279 0.305-1.065 1.041-1.065 2.54s1.090 2.947 1.243 3.150c0.153 0.203 2.16 3.298 5.231 4.625 0.731 0.315 1.301 0.504 1.746 0.645 0.733 0.229 1.401 0.195 1.929 0.118 0.588-0.089 1.796-0.736 2.048-1.447s0.254-1.320 0.178-1.447c-0.076-0.127-0.279-0.203-0.584-0.355z" />
        </svg>
      </a>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainWebsite />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/applications" element={<ApplicationsPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/packaging" element={<PackagingPage />} />
        <Route path="/quality" element={<QualityPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/request-quote" element={<RequestQuotePage />} />
        <Route path="/request-sample" element={<RequestSamplePage />} />
        <Route path="/request-coa" element={<RequestCOAPage />} />
        {/* Product Detail Pages */}
        <Route path="/product/ashwagandha" element={<AshwagandhaPage />} />
        <Route path="/product/moringa" element={<MoringaPage />} />
        <Route path="/product/turmeric" element={<TurmericPage />} />
        <Route path="/product/ginger" element={<GingerPage />} />
        <Route path="/product/amla" element={<AmlaPage />} />
        <Route path="/product/neem" element={<NeemPage />} />
        <Route path="/product/tulsi" element={<TulsiPage />} />
        <Route path="/product/brahmi" element={<BrahmiPage />} />
        <Route path="/product/shikakai" element={<ShikakaiPage />} />
        <Route path="/product/reetha" element={<ReethaPage />} />
        <Route path="/farmer-partnership" element={<FarmerPartnershipPage />} />
      </Routes>
    </Router>
  );
}

export default App;